/* Distri Select · Refonte 2026 — interactions (annonce, sticky, menu, dates, produit) */
(function(){
  var MOIS = ['janvier','fevrier','mars','avril','mai','juin','juillet','aout','septembre','octobre','novembre','decembre'];
  var MOIS_FR = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
  function frDate(d){ return (d.getDate() === 1 ? '1ᵉʳ' : d.getDate()) + ' ' + MOIS_FR[d.getMonth()]; }
  function addDays(d, n){ var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  var now = new Date();
  /* Livraison : 10 jours calendaires maximum après la commande */
  var LIVRAISON_RANGE = 'livré au plus tard le ' + frDate(addDays(now, 10));
  document.querySelectorAll('[data-livraison-range]').forEach(function(el){ el.textContent = el.getAttribute('data-prefix') + LIVRAISON_RANGE; });
  var dow = now.getDay();
  var nextSun = dow === 0 ? now : addDays(now, 7 - dow);
  var weekMon = addDays(nextSun, 15);
  document.querySelectorAll('[data-deadline]').forEach(function(el){
    el.textContent = (dow === 0 ? 'Commandez avant ce soir' : 'Commandez avant dimanche soir')
      + ' pour une livraison la semaine du ' + frDate(weekMon);
  });

  /* annonce : fermeture memorisee 7 jours (surtout utile en mobile) */
  var annBar = document.getElementById('annonce'), annX = document.getElementById('annonceX');
  var ANN_KEY = 'ds_annonce_close';
  if(annBar){
    try { if(localStorage.getItem(ANN_KEY) && Date.now() - parseInt(localStorage.getItem(ANN_KEY), 10) < 6048e5) annBar.hidden = true; } catch(e){}
    if(annX) annX.addEventListener('click', function(){
      annBar.hidden = true;
      try { localStorage.setItem(ANN_KEY, String(Date.now())); } catch(e){}
    });
  }

  /* annonce rotative */
  var annEl = document.getElementById('annonceMsg');
  if(annEl){
    var msgs = [annEl.dataset.m1, annEl.dataset.m2, annEl.dataset.m3].filter(Boolean);
    var aIdx = 0;
    if(msgs.length > 1) setInterval(function(){
      annEl.classList.add('fade');
      setTimeout(function(){ aIdx = (aIdx + 1) % msgs.length; annEl.textContent = msgs[aIdx]; annEl.classList.remove('fade'); }, 400);
    }, 5200);
  }

  /* sticky + widgets */
  var sticky = document.getElementById('sticky'), wa = document.getElementById('wa');
  var showAt = document.getElementById('dsProduct') ? 260 : 640;
  window.addEventListener('scroll', function(){
    var show = window.scrollY > showAt;
    if(sticky && !sticky.dataset.observee) sticky.classList.toggle('on', show);
    if(wa) wa.classList.toggle('up', show);
    document.querySelectorAll('.rv:not(.in)').forEach(function(el){
      if(el.getBoundingClientRect().top < window.innerHeight){ el.classList.add('in'); }
    });
  }, {passive:true});

  /* reveal */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); }, {threshold:.12});
    document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });
  } else { document.querySelectorAll('.rv').forEach(function(el){ el.classList.add('in'); }); }

  /* menu mobile */
  var burger = document.getElementById('burger'), mnav = document.getElementById('mnav');
  if(burger && mnav){
    function closeM(){ mnav.classList.remove('open'); burger.setAttribute('aria-expanded','false'); }
    burger.addEventListener('click', function(){ var o = mnav.classList.toggle('open'); burger.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    var mc = document.getElementById('mnavClose');
    if(mc) mc.addEventListener('click', function(e){ e.preventDefault(); closeM(); });
    mnav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeM); });
  }

  /* fiche produit : options -> variante, galerie, sticky contextuelle */
  var fp = document.getElementById('dsProduct');
  if(fp){
    var variants = JSON.parse(document.getElementById('dsVariants').textContent);
    var idInput = fp.querySelector('input[name="id"]');
    var groups = fp.querySelectorAll('[data-option-group]');
    function currentSelection(){
      var sel = [];
      groups.forEach(function(g){ var a = g.querySelector('[aria-pressed="true"]'); sel.push(a ? a.dataset.value : null); });
      return sel;
    }
    function syncVariant(){
      var sel = currentSelection();
      var v = variants.find(function(x){ return x.options.every(function(o, i){ return o === sel[i]; }); });
      if(!v) return;
      idInput.value = v.id;
      if(v.featured_media){
        var main = document.getElementById('fpMain');
        var im = document.querySelector('[data-media-id="' + v.featured_media + '"]');
        if(main && im){ main.style.backgroundImage = 'url(' + im.dataset.src + ')';
          document.querySelectorAll('.fp-thumb').forEach(function(t){ t.setAttribute('aria-current', t.dataset.mediaId == v.featured_media ? 'true' : 'false'); }); }
      }
      var swName = document.getElementById('fpSwName');
      if(swName) swName.textContent = sel[1] || '';
    }
    groups.forEach(function(g){ g.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        g.querySelectorAll('button').forEach(function(o){ o.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true'); syncVariant();
      });
    }); });
    document.querySelectorAll('.fp-thumb').forEach(function(t){ t.addEventListener('click', function(){
      var main = document.getElementById('fpMain');
      main.style.backgroundImage = 'url(' + t.dataset.src + ')';
      document.querySelectorAll('.fp-thumb').forEach(function(x){ x.setAttribute('aria-current','false'); });
      t.setAttribute('aria-current','true');
    }); });
    var st = document.getElementById('stTitle'), sb = document.getElementById('stBtn'), ss = document.getElementById('stSub');
    if(st){ st.textContent = fp.dataset.title + ' · lit coffre complet';
      sb.setAttribute('href', '#');
      /* la barre collante passe par le bouton principal : meme formulaire,
         meme evenement submit, donc exactement le meme chemin d'ajout que
         le bouton « Ajouter au panier », options de paiement comprises. */
      sb.addEventListener('click', function(e){
        e.preventDefault();
        var form = fp.querySelector('form[action*="/cart/add"]');
        if(!form) return;
        if(form.requestSubmit) form.requestSubmit();
        else { var b = form.querySelector('[type="submit"]'); if(b) b.click(); else form.submit(); }
      }); }
    syncVariant();
  }
})();
/* ---- drawer panier ---- */
(function(){
  var cd = document.getElementById('cd'), ov = document.getElementById('cdOv');
  if(!cd) return;
  function frPrix(cents){
    var e = Math.round(cents / 100);
    return (e >= 1000 ? Math.floor(e / 1000) + '\u00a0' + ('00' + (e % 1000)).slice(-3) : e) + ' €';
  }
  function openCd(){ cd.classList.add('on'); ov.classList.add('on'); cd.setAttribute('aria-hidden','false'); renderCd(); }
  window.dsOpenCart = openCd;
  function closeCd(){ cd.classList.remove('on'); ov.classList.remove('on'); cd.setAttribute('aria-hidden','true'); }
  ov.addEventListener('click', closeCd);
  document.getElementById('cdX').addEventListener('click', closeCd);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeCd(); });

  /* Reglages de l'offre : memes valeurs que snippets/installment-offer.liquid,
     lues dans le JSON pose par layout/theme.liquid. Le drawer est rendu en
     JavaScript depuis /cart.js, il ne peut pas appeler le snippet Liquid :
     les formulations ci-dessous en sont la transposition, a garder alignees. */
  var cfg = {prop: '_purchase_option_id', count: 6, jours: 30, titre: 'INSTALLMENT PAYMENT DISCOUNT'};
  try { var j = document.getElementById('dsOffre'); if(j) { var o = JSON.parse(j.textContent); for(var k in o) cfg[k] = o[k]; } } catch(e){}

  function echelonne(cart){
    var parLigne = (cart.items || []).some(function(it){
      return it.properties && it.properties[cfg.prop];
    });
    if(parLigne) return true;
    var t = String(cfg.titre || '').toLowerCase();
    if(!t) return false;
    var remises = (cart.cart_level_discount_applications || []).concat(cart.discount_applications || []);
    (cart.items || []).forEach(function(it){ remises = remises.concat(it.line_level_discount_allocations || []); });
    return remises.some(function(d){
      var titre = (d && (d.title || (d.discount_application && d.discount_application.title))) || '';
      return String(titre).toLowerCase().indexOf(t) >= 0;
    });
  }

  function montrer(el, visible){ if(el) el.hidden = !visible; }

  function renderCd(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var box = document.getElementById('cdItems');
      var link = document.getElementById('cartLink');
      var recap = document.getElementById('cdRecap'), totRow = document.getElementById('cdTotRow');
      var note = document.getElementById('cdNote'), go = document.getElementById('cdGo');
      var goSub = document.getElementById('cdGoSub'), sw = document.getElementById('cdSwitch');
      if(link) link.textContent = 'Panier' + (cart.item_count > 0 ? ' · ' + cart.item_count : '');
      if(cart.item_count === 0){
        box.innerHTML = '<div class="cd-empty">Votre panier est vide.<br>Votre chambre, elle, peut être terminée sous 10 jours.</div>';
        document.getElementById('cdTot').textContent = '0 €';
        montrer(recap, false); montrer(totRow, true); montrer(note, false);
        montrer(goSub, false); montrer(sw, false);
        if(go) go.textContent = 'Passer commande';
        return;
      }
      var six = echelonne(cart);
      var total = cart.original_total_price;
      var versement = Math.round(total / cfg.count);
      var restants = cfg.count - 1;
      var court = cfg.count + ' × ' + frPrix(versement) + ' sans frais';
      var html = '';
      cart.items.forEach(function(it, i){
        html += '<div class="cd-it"><img src="' + (it.image || '') + '&width=160" alt="">'
          + '<div class="inf"><b>' + it.product_title.replace('Lit coffre ', '') + '</b>'
          + '<div class="v">' + it.variant_title + '</div>'
          + (six ? '<span class="io-line-note">Paiement en ' + cfg.count + ' × sans frais</span>' : '')
          + '<button class="rm" data-line="' + (i + 1) + '">Retirer</button></div>'
          + '<span class="pr">' + frPrix(it.original_line_price) + '</span></div>';
      });
      box.innerHTML = html;
      document.getElementById('cdTot').textContent = frPrix(cart.total_price);

      montrer(totRow, !six);
      montrer(recap, six);
      montrer(note, six);
      montrer(goSub, six);
      montrer(sw, !six);
      if(six){
        recap.innerHTML =
            '<div class="io-recap-l"><span>Aujourd\'hui</span><b>' + frPrix(versement) + '</b></div>'
          + '<div class="io-recap-l"><span>Puis ' + restants + ' × ' + frPrix(versement) + '</span>'
          + '<em>tous les ' + cfg.jours + ' jours, sans frais</em></div>'
          + '<div class="io-recap-l"><span>Livraison</span><em>incluse (Île-de-France et 300 km autour de Paris)</em></div>'
          + '<div class="io-recap-l io-recap-tot"><span>Total de la commande</span><b>' + frPrix(total) + '</b></div>';
        note.textContent = 'Au moment de payer, vous verrez ' + frPrix(versement)
          + ' à régler aujourd\'hui. Le reste (' + frPrix(total - versement) + ') est réparti en '
          + restants + ' versements sans frais.';
        if(go) go.textContent = 'Commander · ' + frPrix(versement) + ' aujourd\'hui';
        goSub.textContent = 'Total ' + frPrix(total) + ' · sans frais';
      } else {
        if(go) go.textContent = 'Passer commande';
        var lien = (cart.items[0] && cart.items[0].url) || '/collections/tous-les-lits';
        document.getElementById('cdSwitchSum').textContent = 'Payer en ' + court + ' ?';
        document.getElementById('cdSwitchTxt').innerHTML = 'Le mode de paiement se choisit sur la fiche produit : ouvrez <a href="'
          + lien + '">la fiche de votre lit</a>, cochez « ' + court + ' », puis remettez-le au panier. Total '
          + frPrix(total) + ', identique au paiement en une fois.';
      }
      box.querySelectorAll('.rm').forEach(function(b){
        b.addEventListener('click', function(){
          fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({line: parseInt(b.dataset.line, 10), quantity: 0})})
            .then(function(){ renderCd(); });
        });
      });
    });
  }

  var link = document.getElementById('cartLink');
  if(link){ link.addEventListener('click', function(e){ e.preventDefault(); openCd(); }); }
  renderCd();

  /* Un meme lit ajoute deux fois avec deux modes de paiement differents cree
     deux lignes distinctes (les proprietes de ligne different). On garde la
     derniere intention du client : les lignes du meme variant portant l'autre
     mode de paiement sont retirees. Aucune donnee de SPD n'est modifiee, on
     supprime seulement une ligne devenue caduque. */
  function modeLigne(item){
    return (item && item.properties && item.properties[cfg.prop]) ? String(item.properties[cfg.prop]) : 'full';
  }
  function retirerDoublons(ajoute){
    if(!ajoute || !ajoute.variant_id) return Promise.resolve();
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var mode = modeLigne(ajoute);
      var aRetirer = [];
      (cart.items || []).forEach(function(it, i){
        if(it.variant_id === ajoute.variant_id && modeLigne(it) !== mode) aRetirer.push(i + 1);
      });
      return aRetirer.sort(function(a, b){ return b - a; }).reduce(function(chaine, ligne){
        return chaine.then(function(){
          return fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({line: ligne, quantity: 0})});
        });
      }, Promise.resolve());
    }).catch(function(){});
  }

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      fetch('/cart/add.js', {method: 'POST', body: new FormData(form)})
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(ajoute){ return retirerDoublons(ajoute); })
        .then(function(){ openCd(); })
        .catch(function(){ form.submit(); });
    });
  });
})();
/* ---- exit popup ---- */
(function(){
  var ov = document.getElementById('xpOv');
  if(!ov) return;
  var KEY = 'ds_exit_seen';
  try { if(localStorage.getItem(KEY) && Date.now() - parseInt(localStorage.getItem(KEY), 10) < 6048e5) return; } catch(e){}
  var shown = false;
  function show(){
    if(shown) return; shown = true;
    ov.classList.add('on');
    try { localStorage.setItem(KEY, String(Date.now())); } catch(e){}
  }
  function close(){ ov.classList.remove('on'); }
  document.getElementById('xpX').addEventListener('click', close);
  document.getElementById('xpNo').addEventListener('click', close);
  document.getElementById('xpGo').addEventListener('click', function(){
    var code = this.dataset.code;
    try { navigator.clipboard.writeText(code); } catch(e){}
    document.cookie = 'discount_code=' + code + ';path=/;max-age=1209600';
    fetch('/discount/' + encodeURIComponent(code)).catch(function(){});
    close();
    window.location.href = '/collections/tous-les-lits';
  });
  document.addEventListener('mouseout', function(e){
    if(!e.relatedTarget && e.clientY < 12) show();
  });
  if(window.matchMedia('(max-width: 860px)').matches){ setTimeout(show, 30000); }
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
})();
/* ---- fiche produit : option de paiement, libellés dynamiques, barre collante ----
   Aucune donnée envoyée au panier n'est touchée : on lit seulement l'état du
   sélecteur radio posé par l'application SPD (input[name="payment-option"]).
   Le bouton de la barre collante déclenche le formulaire principal, donc le
   payload est rigoureusement identique. */
(function(){
  var fp = document.getElementById('dsProduct');
  if(!fp) return;
  var form = fp.querySelector('form[action*="/cart/add"]');
  var atc = document.getElementById('dsAtc');
  var note = document.getElementById('dsAtcNote');
  var sticky = document.getElementById('sticky');
  var stBtn = document.getElementById('stBtn'), stSub = document.getElementById('stSub');
  if(!form || !atc) return;

  function estEchelonne(){
    var r = form.querySelector('input[name="payment-option"]:checked');
    if(!r) return false;                 /* pas de sélecteur : paiement en une fois */
    return r.value !== 'full';
  }
  function net(v){ return (v || '').replace(/\s+/g, ' ').trim(); }
  function poser(el, prop, val){ if(el && el[prop] !== val) el[prop] = val; }

  function sync(){
    var six = estEchelonne();
    var label = net(six ? atc.dataset.labelSix : atc.dataset.labelFull);
    poser(atc, 'textContent', label);
    if(note){
      poser(note, 'textContent', six ? net(note.dataset.noteSix) : '');
      if(note.hidden === six) note.hidden = !six;
    }
    poser(stBtn, 'textContent', label);
    var sous = net(six && note ? note.dataset.noteSix : atc.dataset.labelFull.replace('Ajouter au panier · ', 'Total '));
    poser(stSub, 'textContent', sous);
    /* le descriptif de l'option échelonnée est réécrit avec les montants du
       thème : l'application les formate au format monétaire de la boutique
       (« €230,00 »), incompatible avec les formulations retenues. Seul le
       texte est touché, aucun champ lu par l'application ne l'est. */
    if(note && note.dataset.long){
      var d = document.querySelector('.spp2__widget-note span, .spp2__widget-note');
      if(d && net(d.textContent) !== net(note.dataset.long)) d.textContent = net(note.dataset.long);
    }
  }

  document.addEventListener('change', function(e){
    if(e.target && e.target.name === 'payment-option') sync();
  });

  /* le widget SPD est injecté après le chargement : on resynchronise à son arrivée */
  var mo = new MutationObserver(function(){ sync(); });
  mo.observe(form, {childList: true, subtree: true});
  window.addEventListener('load', sync);
  sync();

  /* barre collante : visible dès que le bouton principal quitte l'écran */
  if(sticky && 'IntersectionObserver' in window){
    sticky.classList.add('sticky--fp');
    sticky.dataset.observee = '1';
    new IntersectionObserver(function(entries){
      sticky.classList.toggle('on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, {threshold: 0}).observe(atc);
  } else if(sticky){
    sticky.classList.add('sticky--fp');
  }
})();
